import React from 'react';
import styled from 'styled-components';
import { Jumbotron as Jumbo, Container, Col, Row } from 'react-bootstrap';
import Map from './Contact_Map';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import phone_icon from '../../../assets/homePage/contactPage/phone_icon.png';
import email_icon from '../../../assets/homePage/contactPage/email_icon.png';
import website_icon from '../../../assets/homePage/contactPage/website_icon.png';
import address_icon from '../../../assets/homePage/contactPage/address_icon.png';

const Styles = styled.div`
    .contact-text-margin {
        margin-top: 13px;
        margin-left: 1em;
    }

    .title-margin {
        margin-top: 4rem;
    }

    .map-container {
        height: 100vh;
        width: 100%;
        margin: 0;
        padding: 0;
    }

    .icon {
        color: #99B6AE;

        &:hover {
            color: #F2F2F2;
            cursor: pointer;
        }
    }

    .clickable {
        cursor: pointer;

        &:hover {
            color: #99B6AE;
        }
    }

    @media all and (max-width: 1020px) {
        .contact-text-margin {
            margin-top: 7px;
        }

        .contact-icons {
            width: 30px;
            height: 30px;
        }
    }

    @media all and (max-width: 992px) {
        .map-container {
            height: 50vh;
        }

        .title-margin {
            margin-top: 0;
        }

        .contact-info-column {
            margin-top: 3rem;
            margin-bottom: 3rem;
        }
    }

    @media all and (max-width: 576px) {
        .map-container {
            margin-bottom: 3rem;
            height: 25vh;
        }
    }
`

class HomePage_Contact extends React.Component {
    handleClick = (item) => {
        if(item === "website") {
            window.open('http://cims.carleton.ca', "CIMS Lab Website");
        }else if(item === "address"){
            window.open('https://www.google.com/maps/place/VSIM+(Visualization,+Simulation+and+Modeling)/@45.3805357,-75.7023887,17z/data=!4m12!1m6!3m5!1s0x4cce0676c4570021:0x6c968b17d1b20924!2sVSIM+(Visualization,+Simulation+and+Modeling)!8m2!3d45.380532!4d-75.7002!3m4!1s0x4cce0676c4570021:0x6c968b17d1b20924!8m2!3d45.380532!4d-75.7002', "VSIM Map View");
        }
    }

    render() {
        return(
            <Styles>
                <Jumbo fluid className="background-color d-flex m-0 p-0">
                    <Container fluid className="p-0">
                        <Col xs={{span:11, offset:1}}>
                            <Row className="d-flex align-items-center">
                                <Col xs={{span:11}} sm={{span:5}} className="contact-info-column">
                                    <Row>
                                        <Col>
                                            <Row className="title-margin">
                                                <h1>CONTACT</h1>
                                            </Row>
                                            <Row>
                                                <h2 className="title-line">INFORMATION</h2>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="mt-5 mb-5">
                                        <Col>
                                            <Row className="mb-2">
                                                <img
                                                    src={phone_icon}
                                                    width="48px"
                                                    height="48px"
                                                    alt="Phone Icon"
                                                    className="contact-icons"
                                                />
                                                <p className="contact-text-margin">(613)-520-2600</p>
                                            </Row>
                                            <Row className="mb-2">
                                                <img    
                                                    src={email_icon}
                                                    width="48px"
                                                    height="48px"
                                                    alt="Email Icon"
                                                    className="contact-icons"
                                                />
                                                <p className="contact-text-margin">info@cims.carleton.ca</p>
                                            </Row>
                                            <Row className="mb-2">
                                                <img
                                                    src={website_icon}
                                                    width="48px"
                                                    height="48px"
                                                    alt="Website Icon"
                                                    className="contact-icons clickable"
                                                    onClick={() => this.handleClick("website")}
                                                />
                                                <p className="contact-text-margin clickable" onClick={() => this.handleClick("website")}>http://cims.carleton.ca</p>
                                            </Row>
                                            <Row className="mb-2">
                                                <img
                                                    src={address_icon}
                                                    width="48px"
                                                    height="48px"
                                                    alt="Address Icon"
                                                    className="contact-icons"
                                                />
                                                <p className="contact-text-margin clickable" onClick={() => this.handleClick("address")}>
                                                    Carleton Immersive Media Studio<br />
                                                    Carleton University<br />
                                                    Virtual & Simulation Building, 4<sup>th</sup> Floor,<br />
                                                    1125 Colonel By Drive<br />
                                                    Ottawa, ON, K1S 5B6         
                                                </p>
                                            </Row>
                                        </Col>
                                    </Row>
                                    {/*<Row>
                                        <FontAwesomeIcon icon={['fab', 'facebook']} mask={['circle']} size="2x" className="icon 2x" onClick={() => this.handleIconClick("facebook")} />
                                        <FontAwesomeIcon icon={['fab', 'instagram']} mask={['circle']} size="2x" className="ml-5 icon 2x" onClick={() => this.handleIconClick("instagram")} />
                                        <FontAwesomeIcon icon={['fab', 'twitter']} mask={['circle']} size="2x" className="ml-5 icon 2x" onClick={() => this.handleIconClick("twitter")} />
                                    </Row>*/}
                                </Col>
                                <Col xs={{span:11}} sm={{span:7}} className="p-0 m-0">
                                    <Row className="map-container">
                                        <Map />
                                    </Row>
                                </Col>
                            </Row>
                        </Col>                       
                    </Container>
                </Jumbo>
            </Styles>
        );
    }
}

export default HomePage_Contact;